import React from 'react';

import Spinner from '../Spinner/index.jsx';
import ArticleBookmark from '../ArticleBookmark/index.jsx';
import articleModalService from '../../Services/ArticleModal/index.jsx';


class ArticleBookmarkSinglePost extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      error: null,
      article: null
    };
    this.getArticle = this.getArticle.bind(this);
    this.fetchError = this.fetchError.bind(this);

  }

  /**
   * retrieve article details from the article slug.
   */
  componentDidMount() {
    this.getArticle();
  }

  getArticle() {
    articleModalService.fetchArticle(this.props.postSlug)
    .then((result) => {
      if (result) {
        this.setState({
          article: result,
          ready: true
        });
      } else {
        console.error('Bookmark Error: article not found or you may not have permission to access it!')
      }
    })
    .catch(this.fetchError);
  }

  fetchError(error) {
    this.setState({ error: error });
  }

  render() {
    var result;

    if (this.state.ready) {
      result = (
        <ArticleBookmark
          article={this.state.article}
        />
      );
    } else {
      result = <Spinner/>;
    }

    
    return result;
  }
}

export default ArticleBookmarkSinglePost;

